module.exports = __webpack_public_path__ + "static/media/instagram-logo.76741406.svg";